(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogJsonPreview', {
    controller: ChangelogJsonPreviewController,
    controllerAs: 'vm',
    bindings: {
      diffObject: '<'
    },
    templateUrl: '/scripts/shared/components/changelog/changelog-delta/changelog-json-preview/changelog-json-preview.view.html'
  });

  function ChangelogJsonPreviewController(

  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.jsonObject = JSON.stringify(vm.diffObject, null, 2);
    }

  }
})();
